import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "core-js/modules/es.object.to-string.js";
import { bingingAdviser, getAdviserInfo as _getAdviserInfo, getAdviserList as _getAdviserList } from '@/api/compliance/index';
export default {
  data: function data() {
    return {
      loading: false,
      visible: false,
      visibleInfo: false,
      adviserInfo: {},
      // 顾问信息
      dataList: [] // 顾问列表
    };
  },
  methods: {
    /**
     * 显示弹窗
     */
    showPopup: function showPopup() {
      var _this = this;
      this.getAdviserInfo().then(function (res) {
        if (res.data) {
          _this.visibleInfo = true;
        } else {
          _this.getAdviserList();
          _this.visible = true;
        }
      });
    },
    /**
     * 获取顾问列表
     */
    getAdviserList: function getAdviserList() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        _this2.loading = true;
        _getAdviserList().then(function (res) {
          _this2.dataList = res.data;
          resolve(res);
        }).catch(function (error) {
          reject(error);
        }).finally(function (_) {
          _this2.loading = false;
        });
      });
    },
    /**
     * 获取顾问信息
     */
    getAdviserInfo: function getAdviserInfo() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        _this3.loading = true;
        _getAdviserInfo().then(function (res) {
          _this3.adviserInfo = res.data || {};
          resolve(res);
        }).catch(function (error) {
          reject(error);
        }).finally(function (_) {
          _this3.loading = false;
        });
      });
    },
    /**
     * 绑定顾问
     */
    bindAdviser: function bindAdviser(item) {
      var _this4 = this;
      _Dialog.confirm({
        title: "\u786E\u8BA4\u7ED1\u5B9A\u987E\u95EE:".concat(item.name, "?")
      }).then(function () {
        bingingAdviser({
          adviserCode: item.adviserCode
        }).then(function () {
          _this4.visible = false;
          _this4.visibleInfo = true;
          _this4.adviserInfo = item;
          _this4.$toast.success('绑定成功');
        }).catch(function () {
          _this4.$toast.fail('绑定失败');
        });
      }).catch(function () {});
    }
  }
};